import { configModel } from 'APP/model/model';
import Entities from 'STORE';

export async function updateHostConfig(): Promise<boolean> {
  try {
    const hostConfig = await configModel.getHostConfig();

    if (!hostConfig) {
      Entities.clientConfig.resetHostConfig();
      return false;
    }
    Entities.clientConfig.setHostConfig(hostConfig);
    return true;
  } catch {
    Entities.clientConfig.resetHostConfig();
    return false;
  }
}
